import { apiPost } from "@/dal";

const MERCHANT_STORAGE_KEY = "myEconomy.receiptMerchants.v1";

// Phase 1 has one shared destination. The backend enforces the same value.
export const RECEIPT_RECIPIENT = "skaanvik@gmail.com";

function normalizeMerchantName(name) {
   return (name || "")
      .trim()
      .replace(/\s+/g, " ")
      .toLocaleLowerCase("nb-NO");
}

function readMerchants() {
   try {
      const merchants = JSON.parse(localStorage.getItem(MERCHANT_STORAGE_KEY) || "[]");
      return Array.isArray(merchants) ? merchants : [];
   } catch (error) {
      return [];
   }
}

function writeMerchants(merchants) {
   localStorage.setItem(MERCHANT_STORAGE_KEY, JSON.stringify(merchants));
}

function sortMerchants(merchants) {
   return merchants.sort((left, right) => {
      if (right.usageCount !== left.usageCount) {
         return right.usageCount - left.usageCount;
      }

      return new Date(right.lastUsedAt).getTime() - new Date(left.lastUsedAt).getTime();
   });
}

function rememberMerchant(name) {
   const displayName = (name || "").trim().replace(/\s+/g, " ");
   const normalizedName = normalizeMerchantName(displayName);
   if (!normalizedName) {
      return;
   }

   const merchants = readMerchants();
   const existing = merchants.find((merchant) => merchant.normalizedName === normalizedName);

   if (existing) {
      existing.name = displayName;
      existing.usageCount += 1;
      existing.lastUsedAt = new Date().toISOString();
   } else {
      merchants.push({
         name: displayName,
         normalizedName: normalizedName,
         usageCount: 1,
         lastUsedAt: new Date().toISOString(),
      });
   }

   writeMerchants(merchants);
}

function receiptError(error) {
   const response = error && error.response;
   const message = response && response.data && response.data.message;
   return new Error(message || "Kvitteringen kunne ikke sendes. Prøv igjen.");
}

export function getMerchantSuggestions() {
   return Promise.resolve(sortMerchants(readMerchants()));
}

export function sendReceipt(receipt) {
   if (!receipt.image) {
      return Promise.reject(new Error("Velg et bilde av kvitteringen først."));
   }

   const form = new FormData();
   form.append("image", receipt.image, receipt.image.name);
   form.append("merchant", receipt.merchant || "");
   form.append("receiptDate", receipt.receiptDate);
   form.append("comment", receipt.comment || "");
   form.append("submissionId", receipt.submissionId);

   return apiPost("receipts/send", form)
      .then((result) => {
         try {
            rememberMerchant(receipt.merchant);
         } catch (error) {
            // Email delivery has succeeded even if browser storage is unavailable.
         }
         return result;
      })
      .catch((error) => {
         throw receiptError(error);
      });
}
